module.exports = __webpack_public_path__ + "static/media/img_homepage_content_Resourcefoyou-02_Primary-School.453fc24b.png";